(() => {
  const init = (root) => {
    if (!root || root.dataset.lookbookReady === 'true') return;
    root.dataset.lookbookReady = 'true';
    const track = root.querySelector('[data-lookbook-track]');
    if (track) {
      // Desktop: click + drag. Touch/iPhone stays 100% native — no preventDefault on touch.
      let mouseDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        mouseDragging = true;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-mouse-dragging');
        track.setPointerCapture?.(event.pointerId);
      });

      track.addEventListener('pointermove', (event) => {
        if (!mouseDragging || event.pointerType !== 'mouse') return;
        track.scrollLeft = startScrollLeft - (event.clientX - startX);
      });

      const stopMouseDrag = (event) => {
        if (!mouseDragging) return;
        mouseDragging = false;
        track.classList.remove('is-mouse-dragging');
        if (event && track.hasPointerCapture?.(event.pointerId)) track.releasePointerCapture(event.pointerId);
      };

      track.addEventListener('pointerup', stopMouseDrag);
      track.addEventListener('pointercancel', stopMouseDrag);
      track.addEventListener('lostpointercapture', stopMouseDrag);
    }

    const grid = root.querySelector('[data-product-grid]');
    if (!grid) return;
    grid.querySelectorAll('.sekany-lookbook-product__media img').forEach((image) => {
      image.loading = 'eager';
      if (!image.complete && image.src) {
        const source = image.src;
        image.removeAttribute('src');
        image.src = source;
      }
    });
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const count = root.querySelector('[data-product-count]');
    const updateCount = () => {
      if (count) count.textContent = `${cards.filter((card) => !card.hidden).length} produits`;
    };
    root.querySelectorAll('[data-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-filter]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        const filter = button.dataset.filter;
        cards.forEach((card) => { card.hidden = filter !== 'all' && !(card.dataset.colors || '').split(' ').includes(filter); });
        updateCount();
      });
    });
    const sort = root.querySelector('[data-product-sort]');
    if (sort) sort.addEventListener('change', () => {
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'title-asc') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      ordered.forEach((card) => grid.appendChild(card));
    });
    root.querySelectorAll('[data-quick-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const card = toggle.closest('[data-product-card]');
        const panel = card && card.querySelector('[data-quick-panel]');
        if (!panel) return;
        const opening = panel.hidden;
        root.querySelectorAll('[data-quick-panel]').forEach((item) => { item.hidden = true; });
        root.querySelectorAll('[data-quick-toggle]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', String(opening));
      });
    });
  };
  const initAll = () => document.querySelectorAll('[data-lookbook-section]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
